import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=97c80f42&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=97c80f42&prod&lang=scss&scoped=true"
import style1 from "./Questions.vue?vue&type=style&index=1&id=97c80f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c80f42",
  null
  
)

export default component.exports